/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useContext, useEffect, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { LIST_NAME } from '../../../../assets/ts/data/q-and-a'
import { openFile } from '../../../../assets/ts/files/files'
import { DocumentIconNames } from '../../../../assets/ts/general/general'
import Accordions from '../../../../components/accordions/accordions'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import useQandA from '../../../../hooks/use-q-and-a'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import NO_RESULTS from '../../../../utils/constants/no-results'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import AddEditView from './add-edit-view'

const SettingsQA = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  initialSquadronOptions,
  roleContext,
  visibleSquadrons,
}: any) => {
  const { categories, components, majcoms, sections } = useContext(MetadataContext)
  const { fetchQAndA, qAndA } = useQandA({
    isArchivedFilter: null,
  })

  const [sectionOptions, setSectionOptions] = useState<any[]>(initialMajcomOptions)
  const [majcomOptions, setMajcomOptions] = useState<any[]>(initialSectionOptions)
  const [squadronOptions, setSquadronOptions] = useState<any[]>(initialSquadronOptions)

  const [inputValues, setInputValues] = useState({
    assignedComponentCode: ALL_SELECT_VALUE,
    majcomCode: ALL_SELECT_VALUE,
    sectionCode: ALL_SELECT_VALUE,
    squadron: ALL_SELECT_VALUE_STRING,
  })

  const [filteredQAndA, setFilteredQAndA] = useState<any[]>([])

  const [clickedItem, setClickedItem] = useState(false)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })

  useEffect(() => {
    setMajcomOptions(initialMajcomOptions)
    setSectionOptions(initialSectionOptions)
    setSquadronOptions(initialSquadronOptions)
  }, [initialMajcomOptions, initialSectionOptions, initialSquadronOptions])

  useEffect(() => {
    let majcomValue = ALL_SELECT_OPTION.value
    let majcomLabel = ALL_SELECT_OPTION.label
    let assigneComponentValue = ALL_SELECT_OPTION.value
    let sectionLabel = ALL_SELECT_OPTION.label
    let sectionValue = ALL_SELECT_OPTION.value
    let squadronValue = ALL_SELECT_OPTION_STRING.value

    if (initialMajcomOptions.length === 1) {
      majcomValue = initialMajcomOptions[0].value
      majcomLabel = initialMajcomOptions[0].label
    }

    if (assignedComponentOptions.length === 1) {
      assigneComponentValue = assignedComponentOptions[0].value
    }

    if (initialSectionOptions.length === 1) {
      sectionValue = initialSectionOptions[0].value
      sectionLabel = initialSectionOptions[0].label
    }

    if (initialSquadronOptions.length === 1) {
      squadronValue = initialSquadronOptions[0].value
    }

    setInputValues((prevState) => ({
      ...prevState,
      assignedComponentCode: assigneComponentValue,
      majcomCode: majcomValue,
      sectionCode: sectionValue,
      squadron: squadronValue,
    }))
  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    initialSquadronOptions,
  ])

  function addEditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
  }
  const onEdit = (item: any) => {
    setShowAddPopup(false)
    if (inEditMode.rowKey === item?.Id) {
      setInEditMode({
        rowKey: null,
        status: true,
      })
      setShowEdit(false)
    } else {
      setInEditMode({
        rowKey: item?.Id,
        status: true,
      })
      setShowEdit(true)
    }
  }
  const onAccordion = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }

  const onCancel = () => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowEdit(!showEdit)
  }

  async function deleteQAndA(item) {
    const lists = await mpfRListsHttp().getList(LIST_NAME)
    await lists.deleteItem(item.eKey, item.eTag)
  }

  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      await deleteQAndA(item)
      await fetchQAndA()
    }

    setClickedItem(false)
  }

  const onDelete = async (item: any) => {
    setClickedItem(item)

    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }

  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter((item) => item.assignedComponentCode === e.value || e.value === -1)
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections
      .filter((section) => {
        let containsSquadron = false

        Object.keys(visibleSquadrons).forEach((key) => {
          if (visibleSquadrons[key].length > 0) {
            const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

            if (key === 'SectionChief' || key === 'SectionOwner') {
              if (
                visibleSquadrons[key].some(
                  (e) =>
                    e.section === formattedSection &&
                    majOptions.some((maj) => e.squadron.includes(maj.squadron))
                )
              ) {
                containsSquadron = true
              }
            }
          }
        })

        return (
          containsSquadron ||
          roleContext?.isCPOwner ||
          roleContext?.isMPFOwner ||
          roleContext?.isMAJCOMOwner ||
          roleContext?.isAssignedComponentOwner
        )
      })
      .map((section) => {
        const filteredSectOpt = initialSectionOptions.filter(
          (sect) => sect.value === section?.SectionCode
        )[0]

        return {
          label: section?.Section,
          majcom: filteredSectOpt.majcom,
          squadron: filteredSectOpt.squadron,
          value: section?.SectionCode,
        }
      })

    const squadOptions: any = [
      ...majOptions
        .filter((majcom) => majcom.squadron)
        .map((majcom) => ({
          label: majcom.squadron,
          value: majcom.squadron,
        })),
    ]

    let majcomValue: any = ALL_SELECT_OPTION.value
    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    } else if (majOptions.length === 1) {
      majcomValue = majOptions[0].value
    }

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (squadOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      majcomCode: majcomValue,
      sectionCode: sectionValue,
      squadron: squadronValue,
    }))
  }
  const onMajcomChange = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections
      .filter((section) => {
        let containsSquadron = false

        Object.keys(visibleSquadrons).forEach((key) => {
          if (visibleSquadrons[key].length > 0) {
            const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

            if (key === 'SectionChief' || key === 'SectionOwner') {
              if (
                visibleSquadrons[key].some(
                  (sect) =>
                    sect.section === formattedSection &&
                    (e.squadron.includes(sect.squadron) || e.value === -1)
                )
              ) {
                containsSquadron = true
              }
            }
          }
        })

        return (
          containsSquadron ||
          roleContext?.isCPOwner ||
          roleContext?.isMPFOwner ||
          roleContext?.isMAJCOMOwner ||
          roleContext?.isAssignedComponentOwner
        )
      })
      .map((section) => {
        const filteredSectOpt = initialSectionOptions.filter(
          (sect) => sect.value === section?.SectionCode
        )[0]

        return {
          label: section?.Section,
          majcom: filteredSectOpt.majcom,
          squadron: filteredSectOpt.squadron,
          value: section?.SectionCode,
        }
      })

    const squadOptions: any = [
      ...majcomOptions
        .filter((majcom) => majcom.squadron)
        .map((majcom) => ({
          label: majcom.squadron,
          value: majcom.squadron,
        })),
    ]

    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (sectOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    setInputValues((prevState) => ({
      ...prevState,
      majcomCode: e.value,
      sectionCode: sectionValue,
      squadron: squadronValue,
    }))
  }

  function onSquadronChange(e: { label: string; value: number }) {
    const sectOptions: optionsTypes[] = sections
      .filter((section) => {
        let containsSquadron = false

        Object.keys(visibleSquadrons).forEach((key) => {
          if (visibleSquadrons[key].length > 0) {
            const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

            if (key === 'SectionChief' || key === 'SectionOwner') {
              if (
                visibleSquadrons[key].some(
                  (sect) =>
                    sect.section === formattedSection &&
                    (sect.squadron === e.value || e.value === -1)
                )
              ) {
                containsSquadron = true
              }
            }
          }
        })

        return (
          containsSquadron ||
          roleContext?.isCPOwner ||
          roleContext?.isMPFOwner ||
          roleContext?.isMAJCOMOwner ||
          roleContext?.isAssignedComponentOwner
        )
      })
      .map((section) => {
        const filteredSectOpt = initialSectionOptions.filter(
          (sect) => sect.value === section?.SectionCode
        )[0]

        return {
          label: section?.Section,
          majcom: filteredSectOpt.majcom,
          squadron: filteredSectOpt.squadron,
          value: section?.SectionCode,
        }
      })

    let sectionValue: any = ALL_SELECT_OPTION.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    setInputValues((prevState) => ({
      ...prevState,
      sectionCode: sectionValue,
      squadron: e.value,
    }))
  }

  const onSectionChange = (e: { label: string; value: number }) => {
    setInputValues((prevState) => ({
      ...prevState,
      sectionCode: e.value,
    }))
  }

  const accordionContent = (qa: any, AttachedFileName: any, index: number) => {
    return (
      <div>
        {inEditMode?.rowKey === qa?.Id ? (
          <AddEditView
            assignedComponentOptions={assignedComponentOptions}
            cancel={() => onCancel()}
            categories={categories}
            clickedIndex={index}
            components={components}
            fetchQAndA={fetchQAndA}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            initialSquadronOptions={initialSquadronOptions}
            majcoms={majcoms}
            qAndA={qa}
            roleContext={roleContext}
            sections={sections}
            showAddPopup={showAddPopup}
            showEdit={showEdit}
            visibleSquadrons={visibleSquadrons}
          />
        ) : (
          <>
            <div
              aria-live='polite'
              className='my-2 pb-2 border-bottom1 d-flex flex-column p-2'
              tabIndex={0}
            >
              {clickedItem && (
                <Alert
                  alerttextclass='poppins-semibold font-13 text-center'
                  btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
                  btn1iconclassNmae='icon-checked font-12 pe-1'
                  btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
                  btn2iconclassNmae='icon-close color-primary font-12 pe-1'
                  cancel='Cancel'
                  className='alert-info'
                  message={DELETE_MESSAGE}
                  onClick={(e) => onClickAlert(e, clickedItem)}
                  yes='OK'
                />
              )}
              <span className='poppins-medium font-12  pb-1'>Description</span>
              <span
                className='poppins-medium font-12 subtitle-color1 pb-1 lh-normal'
                dangerouslySetInnerHTML={{ __html: qa.Description }}
              />
            </div>
            <div className='d-flex flex-column p-2'>
              <span className='poppins-medium font-12 title-color2 pb-1'>Attachments</span>
              <ul>
                <li>
                  {qa?.Attachments[0]?.blobs.length > 0 &&
                    qa.Attachments[0].blobs.map((blob) => (
                      <a
                        className='color-primary poppins-medium font-12 text-capitalize maxfitcontent'
                        href='#'
                        key={blob.fileName}
                        onClick={() => openFile(blob, qa.eKey, LIST_NAME)}
                        tabIndex={0}
                        title={blob.fileName}
                      >
                        <span className='color-primary'>
                          <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
                          {blob.fileName}
                        </span>
                      </a>
                    ))}
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    )
  }

  useEffect(() => {
    const filteredQA = qAndA
      .filter((qAEntry) => {
        if (Object.keys(qAEntry).length > 0) {
          return (
            ((inputValues.assignedComponentCode === -1 &&
              assignedComponentOptions.some(
                (e) =>
                  e.value === qAEntry.AssignedComponentCode ||
                  (!qAEntry.AssignedComponentCode && inputValues.assignedComponentCode === -1)
              )) ||
              (qAEntry.AssignedComponentCode === inputValues.assignedComponentCode &&
                (inputValues.majcomCode === -1 ||
                  qAEntry.ServicingMAJCOMCode === inputValues.majcomCode) &&
                majcomOptions.some(
                  (e) =>
                    (e.value === qAEntry.ServicingMAJCOMCode &&
                      qAEntry.AssignedComponentCode === e.assignedComponentCode) ||
                    (!qAEntry.ServicingMAJCOMCode && inputValues.majcomCode === -1)
                ) &&
                qAEntry?.SectionCodes?.every((section) =>
                  initialSectionOptions.some((e) => e.value === section)
                ))) &&
            (inputValues.sectionCode === -1 ||
              qAEntry?.SectionCodes?.some((sec) => sec === inputValues.sectionCode)) &&
            (inputValues.squadron === '' || qAEntry.Squadron === inputValues.squadron)
          )
        } else {
          return
        }
      })
      .map((qaEntry) => ({
        ...qaEntry,
        Category: qaEntry.Category.length === 0 ? 'All' : qaEntry.Category,
        Section: qaEntry.Section.length === 0 ? 'All' : qaEntry.Section.join(', '),
        ServicingOrganization: qaEntry.Squadron === '' ? 'All' : qaEntry.Squadron,
      }))
    setFilteredQAndA(filteredQA)
  }, [qAndA, inputValues])
  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={assignedComponentOptions}
                value={inputValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomOptions}
                value={inputValues.majcomCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingOrganization'
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronOptions}
                value={inputValues.squadron}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11'
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOptions}
                value={inputValues.sectionCode}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setShowAddPopup(!showAddPopup)
                }}
              />
            </div>
          </div>
        }
        name='Q & A'
      />
      <div className='p-0 settings-main mt-2 customaccrdionactive'>
        {showAddPopup && (
          <AddEditView
            assignedComponentOptions={assignedComponentOptions}
            categories={categories}
            components={components}
            fetchQAndA={fetchQAndA}
            filtersvalue={addEditValue}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            initialSquadronOptions={initialSquadronOptions}
            majcoms={majcoms}
            roleContext={roleContext}
            sections={sections}
            showAddPopup={showAddPopup}
            visibleSquadrons={visibleSquadrons}
          />
        )}

        {filteredQAndA.length > 0 ? (
          <Accordions
            IsEdit={onEdit}
            ItemId={inEditMode?.rowKey}
            accordionitemclass='shadow card mb-2 my-2 mx-2'
            actions={[
              {
                alabel: 'Edit',
                className:
                  'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold',
                icon: 'icon-pencil me-xl-1 font-10',
                label: 'Edit',
                onClick: onEdit,
              },
              {
                alabel: 'Delete',
                className:
                  'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold',
                icon: 'icon-trashbin me-xl-1 font-10',
                label: 'Delete',
                onClick: onDelete,
              },
            ]}
            className='accordions'
            count='bordered px-1 ms-1 border-radius'
            dataobj={onAccordion}
            defaultActivekey='1'
            dividerClass='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'
            extrasClass='d-flex flex-column flex-md-row flex-wrap w-100'
            headerextras={[
              { classq: 'me-auto my-2 col', name: 'Question' },
              { classq: 'w-100 min-w-md-150 max-w-150 my-2', name: 'AssignedComponent' },
              { classq: 'w-100 min-w-md-150 max-w-150 my-2', name: 'ServicingMAJCOM' },
              { classq: 'w-100 min-w-md-150 max-w-150 my-2', name: 'ServicingOrganization' },
              { classq: 'w-100 min-w-md-150 max-w-150 my-2', name: 'Section' },
              { classq: 'w-100 min-w-md-100 max-w-100 my-2', name: 'Category' },
              { classq: 'w-100 min-w-md-100 max-w-100 my-2', name: 'Status' },
              { classq: 'text-nowrap w-100 max-w-80', name: 'IsArchived' },
            ]}
            inputProps={{
              accordionheadClass: 'd-flex align-items-center px-2 py-3 custombg',
              className: 'justify-content-start poppins-medium font-13 w-100 p-0',
              contentclassName: 'p-0',
            }}
            isSettings={true}
            items={filteredQAndA}
            renderHtml={accordionContent}
            titleIcon='icon-minusform font-16 color-primary pe-2'
            titleclassName='title-color35 poppins-semibold font-12'
            titlecollapsedIcon='icon-plusform pe-2 font-16 color-primary'
            titlecontentclassName='poppins-semibold font-12 title-color2 lineClamp2 pe-2 breakall'
          />
        ) : (
          <div>
            <NO_RESULTS />
          </div>
        )}
      </div>
    </div>
  )
}
export default SettingsQA
